module.exports = __webpack_public_path__ + "static/beaside-logo-691522ebbff9fbd6a882c14a37385023.svg";